import { render, staticRenderFns } from "./multi-choice.vue?vue&type=template&id=a6bfecda&scoped=true"
import script from "./multi-choice.vue?vue&type=script&lang=js"
export * from "./multi-choice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bfecda",
  null
  
)

export default component.exports